import React, { useEffect, useState, memo } from 'react'
import { upAxios } from '../../config'
import { Loader } from '../ui-kit'

type Props = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> & {
  /**
   * axios data object - if present, request will be post
   */
  data?: any
  showLoading?: boolean
  loaderProps?: object
}

export const ImgFromAPI: React.FC<Props> = memo(props => {
  const [dataUrl, setDataUrl] = useState('')
  const [loading, setLoading] = useState(false)

  const { src, data, showLoading, loaderProps } = props

  useEffect(() => {
    const conf = {
      responseType: 'blob',
    }

    setLoading(true)
    const promise = data ? upAxios.post(src!, data, conf) : upAxios.get(src!, conf)

    promise
      .then(res => {
        const reader = new FileReader()
        reader.readAsDataURL(res.data)
        reader.onload = () => {
          const imageDataUrl = reader.result
          setDataUrl(imageDataUrl as string)
          setLoading(false)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }, [src, data])

  return showLoading && loading ? (
    <Loader size="large" {...loaderProps} />
  ) : (
    <img {...props} src={dataUrl} alt="" />
  )
})

ImgFromAPI.displayName = 'ImgFromAPI'

// export const InlineSVGFromAPI = memo((props: { src: string }) => {
//   const [dataUrl, setDataUrl] = useState('')

//   const { src } = props

//   useEffect(() => {
//     const conf = {
//       mode: 'no-cors' as 'no-cors',
//     }

//     fetch(src, conf)
//       .then(response => {
//         if (response.ok) {
//           return response.blob()
//         }
//         throw new Error('Network response was not ok.')
//       })
//       .then(myBlob => {
//         const reader = new FileReader()
//         reader.readAsDataURL(myBlob)
//         reader.onload = () => {
//           const imageDataUrl = reader.result

//           setDataUrl(imageDataUrl as string)
//         }
//       })
//   }, [src])

//   return dataUrl !== '' ? (
//     <InlineSVG
//       src={dataUrl}
//       // onError={e => console.log(e)}
//     />
//   ) : null
// })
